export default "__VITE_ASSET__208aaa60__"